/* A wall of recordings: months of poster tiles, newest first. Moved out of
 * `pages/client-detail/ui/Forma.module.css` on its second consumer, `/nagrania`; the Forma gallery's
 * values are unchanged. The card around the wall is the caller's. */

.month {
  display: flex;
  flex-direction: column;
  gap: var(--space-4);
}

.monthTitle {
  margin: var(--space-0);
  padding-top: var(--space-6px);
  font-size: var(--fs-label-md);
  font-weight: var(--fw-bold);
  line-height: var(--lh-auto);
  color: var(--text-2);
}

.tiles {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(var(--w-clip-tile-min), 1fr));
  gap: var(--space-3);
  margin: var(--space-0);
  padding: var(--space-0);
  list-style: none;
}

/* `oneRow`: every row past the first is zero tall, so a count the grid cannot fit is clipped
 * rather than wrapped into a second row the reserve does not hold. */
.oneRow {
  grid-template-rows: auto;
  grid-auto-rows: var(--space-0);
  row-gap: var(--space-0);
  overflow: hidden;
}

.tile {
  display: flex;
  flex-direction: column;
  gap: var(--space-6px);
  width: 100%;
  padding: var(--space-0);
  font: inherit;
  color: var(--text);
  text-align: left;
  cursor: pointer;
  background: transparent;
  border: 0;
  border-radius: var(--radius-sm);
}

.tile:focus-visible {
  outline: var(--border-focus) solid var(--accent);
  outline-offset: var(--space-2px);
}

.poster {
  position: relative;
  display: block;
  width: 100%;
  aspect-ratio: var(--ratio-clip-tile);
  overflow: hidden;
  background: var(--player-stage);
  background-clip: padding-box;
  border: var(--border-hairline) solid var(--border);
  border-radius: var(--radius-sm);
}

.posterImg {
  display: block;
  width: 100%;
  height: 100%;
  transition-duration: var(--dur-slow);
  transition-property: transform;
  transition-timing-function: var(--ease);
}

.tile:hover .posterImg {
  transform: scale(1.03);
}

.duration {
  position: absolute;
  right: var(--space-6px);
  bottom: var(--space-6px);
  display: flex;
  align-items: center;
  height: var(--h-clip-tile-duration);
  padding: var(--space-0) var(--space-5px);
  font-size: var(--fs-eyebrow);
  font-weight: var(--fw-bold);
  color: var(--text-on-photo);
  background: var(--wash-on-photo-badge);
  border-radius: var(--radius-5px);
}

.new {
  position: absolute;
  top: var(--space-6px);
  left: var(--space-6px);
  width: var(--sz-clip-tile-new-dot);
  height: var(--sz-clip-tile-new-dot);
  background: var(--accent);
  border-radius: var(--r-circle);
  box-shadow: var(--ring-on-photo);
}

.name {
  font-size: var(--fs-label-md);
  font-weight: var(--fw-bold);
  line-height: var(--lh-name);
}

.line,
.by,
.client {
  font-size: var(--fs-micro);
  line-height: var(--lh-auto);
  color: var(--text-2);
}

.by,
.client {
  --sz-avatar: var(--sz-clip-tile-avatar);

  display: inline-flex;
  gap: var(--space-5px);
  align-items: center;
}

/* The client over the movement, on a wall of many clients (variant A): the mark reads before the
 * movement, so it carries the weight the author line under it does not. */
.client {
  font-weight: var(--fw-semibold);
}

.skelMonth {
  width: 20%;
  height: var(--fs-label-md);
}

.skelPoster {
  width: 100%;
  aspect-ratio: var(--ratio-clip-tile);

  --radius-bar: var(--radius-sm);
}

.skelLine {
  width: 70%;
  height: var(--fs-note);
}

.skelLineShort {
  width: 45%;
  height: var(--fs-note);
}
